const mockMenuData = {
  FishDishes: [
    {
      category: "Fish Dishes",
      items: [
        {
          name: "Fish / Kala Korma ( L,G )",
          price: 14.90,
          description: "Mildly spiced fish cooked in a creamy coconut-based sauce, creating a balance of rich flavors.",
          finnish: "Mieto, kookospohjainen kermainen kastike maustetulla kalalla.",
          image: "wolt-30.png"
        },
        {
          name: "Fish / Kala Chilli ( L,G,P )",
          price: 14.90,
          description: "Crispy fried fish pieces stir-fried with vegetables and a tangy chili sauce.",
          finnish: "( Rapeaksi paistettua kalaa vihannesten ja tulisen chilikastikkeen kera. )",
          image: "wolt-31.png"
        },
        {
          name: "Fish / Kala Vindaloo ( L,G,P )",
          price: 15.90,
          description: "Spicy fish curry with a tangy vinegar-based sauce, rich in bold Indian spices.",
          finnish: "( Tulinen kalacurry, jossa on hapokas etikkapohjainen kastike. )",
          image: "wolt-32.png"
        },
      ],
    },
  ],
  Momo: [
    {
      category: "Veg Momo / Kasvis Momo (L,P)",
      items: [
        {
          name: "Fry Momo",
          price: 9.90,
          description: "Stuffed with finely chopped vegetables & spices, served with tomato chutney.",
          finnish: "Täytetyt hienonnetuilla vihanneksilla ja mausteilla, tarjoillaan tomaattichutneyn kanssa.",
          image: "wolt-18.png"
        },
        {
          name: "Steam Momo",
          price: 10.90,
          description: "Soft and juicy dumplings, steamed to perfection.",
          finnish: "Pehmeät ja mehukkaat nyytit, jotka höyrytetään täydellisiksi.",
          image: "wolt-21.png"
        },
        {
          name: "Jhol Momo",
          price: 11.90,
          description: "Vegetable momos in a spicy, tangy soup that enhances their flavor.",
          finnish: "Kasvis momoja mausteisessa keitossa.",
          image: "wolt-19.png"
        },
        {
          name: "Chilli Momo",
          price: 11.90,
          description: "Crispy, fried vegetable dumplings perfect for those who enjoy crunch.",
          finnish: "Rapeat paistetut kasvisnyytit, täydellinen valinta rapeuden ystäville.",
          image: "wolt-20.png"
        }
      ]
    },
    {
      category: "Paneer Momo / Paneerilla Momo (L,P)",
      items: [
        {
          name: "Fry Momo",
          price: 9.90,
          description: "Crispy fried dumplings for a flavorful crunch.",
          finnish: "Rapeaksi paistetut nyytit, jotka tarjoavat herkullisen rouskeen.",
          image: ""
        },
        {
          name: "Steam Momo",
          price: 10.90,
          description: "Soft and juicy dumplings, steamed to perfection.",
          finnish: "Pehmeät ja mehukkaat nyytit, jotka höyrytetään täydellisiksi.",
          image: ""
        },
        {
          name: "Jhol Momo",
          price: 11.90,
          description: "Dumplings served in a tangy, mildly spicy soup.",
          finnish: "Nyytit tarjotaan happamassa ja kevyesti mausteisessa keitossa.",
          image: ""
        },
        {
          name: "Chilli Momo",
          price: 12.90,
          description: "Dumplings tossed in a spicy and savory chili sauce.",
          finnish: "Nyytit pyöritetään tulisessa ja maukkaassa chilisoossissa.",
          image: ""
        }
      ]
    },
    {
      category: "Chicken Momo / Kanaa Momo (L,P)",
      items: [
        {
          name: "Fry Momo",
          price: 9.90,
          description: "Deep-fried until golden brown, giving a crispy outer layer while retaining the juicy filling.",
          finnish: "Rapeaksi paistetut nyytit, jotka tarjoavat herkullisen rouskeen.",
          image: ""
        },
        {
          name: "Steam Momo",
          price: 10.90,
          description: "Steamed minced chicken dumplings, tender and flavorful, served with tangy tomato chutney.",
          finnish: "Höyrytetyt broilerin jauhelihapyytit, pehmeitä ja maukkaita, tarjoillaan kirpeän tomaattichutneyn kanssa.",
          image: ""
        },
        {
          name: "Jhol Momo",
          price: 11.90,
          description: "Served in a tangy, spicy soup with aromatic Nepali spices.",
          finnish: "Tarjoillaan kirpeänä, mausteisena keittoa aromaattisilla nepalilaismausteilla.",
          image: ""
        },
        {
          name: "Chilli Momo",
          price: 12.90,
          description: "Dumplings tossed in a spicy and savory chili sauce.",
          finnish: "Nyytit pyöritetään tulisessa ja maukkaassa chilisoossissa.",
          image: ""
        }
      ]
    },
    {
      category: "Lamb Momo / Lampaan Momo (L,P)",
      items: [
        {
          name: "Fry Momo",
          price: 11.90,
          description: "Deep-fried lamb momos with a crisp exterior and a tender, seasoned filling.",
          finnish: "Syväpaistetut lampaan momot rapealla ulkokuorella ja maukkaalla täytteellä.",
          image: ""
        },
        {
          name: "Steam Momo",
          price: 12.90,
          description: "Juicy lamb dumplings, steamed to perfection, with a rich, savory filling.",
          finnish: "Mehevät lampaan nyytit, höyrytetty täydellisesti ja maustettu maukkaiksi.",
          image: ""
        },
        {
          name: "Jhol Momo",
          price: 13.90,
          description: "Steamed lamb momos served in a flavorful, spicy soup.",
          finnish: "Höyrytetyt lampaan momot mausteisessa ja aromaattisessa keitossa.",
          image: ""
        },
        {
          name: "Chilli Momo",
          price: 14.90,
          description: "Lamb momos stir-fried with vegetables in a zesty chili sauce.",
          finnish: "Lampaan momot wokattuna vihannesten ja tulisen chilikastikkeen kanssa.",
          image: ""
        }
      ]
    }
  ],

  ChickenDishes: [
    {
      category: "Chicken / Kana Vindaloo ( L,G,P )",
      items: [
        {
          name: "Chicken Korma (L, G)",
          price: 14.90,
          description: "Spicy chicken curry with bold flavors and a tangy finish, simmered in a tomato-based sauce.",
          finnish: "( Tulinen kanan curry, jossa on mausteinen ja happaman vivahteikas kastike. )",
          image: "wolt-33.png"
        },
        {
          name: "Chicken / Kana Korma ( L,G )",
          price: 15.20,
          description: "Chicken cooked in a creamy, mildly spiced yogurt-based sauce, rich and smooth.",
          finnish: "Mieto kananruoka jogurttipohjaisessa kermakastikkeessa.",
          image: "wolt-34.png"
        },
        {
          name: "Butter Chicken / Kana ( G )",
          price: 15.20,
          description: "Creamy tomato-based curry with tender pieces of chicken, slightly sweet and aromatic",
          finnish: "( Kermaisen tomaattipohjainen kastike, jossa on mureita kananpaloja. )",
          image: "wolt-35.png"
        },
        {
          name: "Chicken / Kana Tikka Masala ( G,P )",
          price: 15.90,
          description: "Grilled chicken tikka in a creamy, spiced masala sauce, full of robust flavors",
          finnish: "( Grillattu kana kermaisessa ja mausteisessa masalakastikkeessa. )",
          image: "wolt-36.png"
        },
      ],
    },
  ],

  TofuDishes: [
    {
      category: "Tofu Dishes",
      items: [
        {
          name: "Tofu Chilli ( L,G,P )",
          price: 12.90,
          description: "Crispy tofu stir-fried with vegetables in a tangy, spicy chili sauce.",
          finnish: "( Rapeaksi paistettu tofu wokattuna vihannesten ja tulisen chilikastikkeen kanssa. )",
          image: "wolt-22.png"
        },
        {
          name: "Tofu Vindaloo (L, G, P)",
          price: 14.90,
          description: "Spicy tofu curry with a tangy, bold sauce, perfect for heat lovers.",
          finnish: "Tulinen tofucurry, jossa on mausteinen ja happaman vivahteikas kastike.",
          image: "wolt-23.png"
        },
        {
          name: "Tofu Tikka Masala ( L,G,P )",
          price: 14.90,
          description: "Grilled tofu cooked in a creamy masala sauce, a delightful vegan-friendly option.",
          finnish: "( Grillattu tofu kermaisessa masalakastikkeessa. )",
          image: "wolt-24.png"
        },
        
      ],
    },
  ],

  PaneerDishes: [
    {
      category: "Paneer Dishes",
      items: [
        {
          name: "Shahi Paneer ( G )",
          price: 14.90,
          description: "Paneer cubes simmered in a curry, nut-based sauce, mildly sweet and aromatic.",
          finnish: "( Paneerpaloja kermaisessa ja pähkinäisessä kastikkeessa. )",
          image: "wolt-25.png"
        },
        
        {
          name: "Paneer Tikka Masala (G, P)",
          price: 15.90,
          description: "Grilled paneer cooked in a spiced tomato and cream-based sauce, rich and flavorful.",
          finnish: "Grillattu paneer kermaisessa tomaatti- ja maustekastikkeessa.",
          image: "wolt-26.png"
        },
        
      ],
    },
  ],

  VegetableDishes: [
    {
      category: "Vegetable Dishes",
      items: [
        {
          name: "Chana Masala (L, G, P)",
          price: 13.90,
          description: "Chickpeas cooked in a tangy, tomato-based curry with bold spices.",
          finnish: "Kikherneitä tomaattipohjaisessa mausteisessa kastikkeessa.",
          image: "wolt-27.png"
        },
        {
          name: "Saag Paneer ( G,P )",
          price: 14.90,
          description: "Paneer cubes in a spiced spinach-based curry, creamy and wholesome.",
          finnish: "( Paneerpaloja maustetussa pinaattikastikkeessa. )",
          image: "wolt-28.png"
        },
        {
          name: "Aloo Gobi ( L,G,P )",
          price: 12.90,
          description: "Potatoes and cauliflower cooked in a mildly spiced curry with Indian herbs",
          finnish: "( Perunoita ja kukkakaalia miedosti maustetussa currykastikkeessa. )",
          image: "wolt-29.png"
        },
      ],
    },
  ],

  LambDishes: [
    {
      category: "Lamb Dishes",
      items: [
        {
          name: "Lamb Korma (L, G)",
          price: 15.20,
          description: "Tender lamb pieces in a rich, creamy, spiced sauce, mildly sweet and aromatic.",
          finnish: "Pehmeitä lampaanpaloja kermaisessa, maustetussa kastikkeessa.",
          image: "wolt-43.png"
        },
        {
          name: "Lamb Masala ( L,G,P )",
          price: 15.20,
          description: "Lamb cooked in a flavorful tomato-based masala with bold Indian spices.",
          finnish: "Lammas tomaattipohjaisessa ja mausteisessa masalakastikkeessa.",
          image: "wolt-44.png"
        }
      ],
    },
  ],

  FriedRice: [
    {
      category: "Fried Rice",
      items: [
        {
          name: "Vegetable Fried Rice",
          price: 9.90,
          description: "Stir-fried rice with mixed vegetables, seasoned with soy sauce and spices.",
          finnish: "Paistettua riisiä tuoreilla vihanneksilla ja soijakastikkeella.",
          image: "wolt-46.png"
        },
        {
          name: "Chicken Fried Rice",
          price: 10.90,
          description: "Stir-fried rice with mixed vegetables, seasoned with soy sauce and spices.",
          finnish: "Paistettua riisiä kanalla, munalla ja mausteilla.",
          image: "wolt-47.png"
        },
        {
          name: "Shrimp Fried Rice",
          price: 11.90,
          description: "Stir-fried rice with mixed vegetables, seasoned with soy sauce and spices.",
          finnish: " Paistettua riisiä katkaravuilla ja yrteillä.",
          image: "wolt-48.png"
        },
        {
          name: "Lamb Fried Rice",
          price: 12.90,
          description: "Savory fried rice with tender lamb and a blend of seasonings.",
          finnish: " Paistettua riisiä lampaanlihan ja mausteiden kera.",
          image: "wolt-49.png"
        },
      ],
    },
  ],
  Naan : [
    {
      category: "Naan",
      items: [
        {
          name: "Plain / Tavallinen Naan",
          price: 1.50,
          description: "Soft, fluffy Indian flatbread..",
          finnish: " Pehmeä intialainen leipä.",
          image: "wolt-50.png"
        },
        {
          name: "Garlic / Valkosipuli Naan",
          price: 1.90,
          description: "Naan topped with minced garlic and butter.",
          finnish: " Valkosipulilla ja voilla päällystetty naan.",
          image: "wolt-51.png"
        },  
        {
          name: "Cheese / Juusto Naan",
          price: 2.90,
          description: "Naan stuffed with melted cheese.",
          finnish: " Juustotäytteinen naan.",
          image: "wolt-52.png"
        },
        {
          name: "Cheese Garlic / Juusto Valkosipuli Naan",
          price: 3.50,
          description: "Naan with a delicious combination of cheese and garlic",
          finnish: " Juuston ja valkosipulin herkullinen yhdistelmä.",
          image: "wolt-53.png"
        },
      ],
    },
  ],
  Noodles : [
    {
      category: "Noodles with Soup",
      items: [
        {
          name: "Vegetable Noodle Soup",
          price: 8.90,
          description: "Warm, comforting noodle soup with fresh vegetables and mild spices.",
          finnish: "Lämmittävä keitto nuudeleilla ja tuoreilla vihanneksilla.",
          image: "wolt-54.png"
        },
        {
          name: "Chicken Noodle Soup",
          price: 9.90,
          description: "Hearty chicken soup with noodles, seasoned with Indian spicesCrispy pastries filled with spiced potatoes and peas.",
          finnish: "Kananmakuinen runsas ja mausteinen keitto nuudeleilla.",
          image: "wolt-55.png"
        },  
        {
          name: "Lamb Noodle Soup ",
          price: 10.90,
          description: "Rich, flavorful lamb soup with noodles for a filling and satisfying meal.",
          finnish: "Runsas lampaanmakuinen keitto nuudeleilla.",
          image: "wolt-56.png"
        },
      ],
    },
  ],
  ChowMein : [
    {
      category: "Chow Mein ( L,P )",
      items: [
        {
          name: "Vegetable Chow Mein",
          price: 10.90,
          description: "Stir-fried noodles with fresh vegetables and Indian seasonings.",
          finnish: " Wokatut nuudelit vihanneksilla ja mausteilla.",
          image: "wolt-57.png"
        },
        {
          name: "Chicken Chow Mein",
          price: 11.90,
          description: "Stir-fried noodles with chicken, vegetables, and soy sauce.",
          finnish: "Wokatut nuudelit kanalla, vihanneksilla ja soijakastikkeella.",
          image: "wolt-58.png"
        },  
      ],
    },
  ],


  Snacks: [
    {
      category: "Snacks (Välipalat)",
      items: [
        {
          name: "Vegetable Samosa (3 pcs)",
          price: 6.90,
          description: "Crispy pastries filled with spiced potatoes and peas.",
          finnish: "Rapeat leivonnaiset, joissa on maustettua peruna- ja hernetäytettä.",
          image: "wolt-59.png"
        },
        {
          name: "Chicken & Chip",
          price: 8.90,
          description: "Fried rice with chicken pieces, eggs, and flavorful spices.",
          finnish: " Paistettua riisiä kanalla, munalla ja mausteilla.",
          image: "wolt-60.png"
        },  
        {
          name: "Fish & Chips",
          price: 9.90,
          description: "Fragrant rice stir-fried with shrimp and Indian herbs.",
          finnish: " Paistettua riisiä katkaravuilla ja yrteillä.",
          image: ""
        },
      ],
    },
  ],

  Beverages: [
    {
      category: "Beverages (Drinks)",
      items: [
        {
          name: "Banana Lassi",
          price: 3.50,
          image: "wolt-62.png"
        },
        {
          name: "Mango Lassi",
          price: 3.50,
          image: "wolt-63.png"
        },
        {
          name: "Sweet Lassi",
          price: 3.50,
          image: "wolt-64.png"
        },
        {
          name: "Coca-Cola",
          price: 3.50,
          image: "wolt-65.png"
        },
        {
          name: "Fanta/Sprite",
          price: 3.50,
          image: "wolt-66.png"
        },
        {
          name: "Coca-Cola Zero",
          price: 3.50,
          image: "wolt-67.png"
        },
        {
          name: "Fanta",
          price: 3.50,
          image: "wolt-68.png"
        },
        {
          name: "Sprite",
          price: 3.50,
          image: "wolt-69.png"
        },
        
      ],
    },
  ],
};

export default mockMenuData;
